import { Injectable } from '@angular/core';

import { PostAccentLightPositionCalculator } from '../../../classes/PostAccentLightPositionCalculator';
import { SizeDetector } from '../../../classes/SizeDetector';
import { ModelLoaderService } from '../../model-loader.service';
import { DataForDisplayingMenuItemsService } from '../../data-for-displaying-menu-items.service';

declare const THREE: any;

@Injectable()
export class PostAccentLightsArrangeService {
  private lightModel;
  private up = new THREE.Vector3(0, 1, 0);
  private lightPositionCalculator = new PostAccentLightPositionCalculator();
  private accentLightSizeDetector = new SizeDetector();
  private lightSize;

  constructor(
    private modelLoaderService: ModelLoaderService,
    private appParams: DataForDisplayingMenuItemsService
  ) {
    this.preloadModel();
  }

  private hasAccentLights(): boolean {
    // need better way to detect whether post support accent light
    return this.appParams.getCurrentParams().railingType === 'DesignRail';
  }

  private async preloadModel() {
    const lightModel = await this.modelLoaderService.loadLocalModel('PostAccentLight');
    lightModel.name = 'PostAccentLight';
    lightModel.visible = false;
    this.lightSize = this.accentLightSizeDetector.detect(lightModel);
    this.lightModel = lightModel;
  }

  add(post, firstPoint, lastPoint) {
    if (!this.hasAccentLights()) {
      return;
    }
    const edgeStart = new THREE.Vector3(firstPoint.x, 0, firstPoint.z);
    const edgeEnd = new THREE.Vector3(lastPoint.x, 0, lastPoint.z);
    const edgeNormal = edgeEnd
      .clone()
      .sub(edgeStart)
      .applyAxisAngle(this.up, THREE.Math.degToRad(-90))
      .normalize();
    const lightModel = this.lightModel.clone();
    const position = this.lightPositionCalculator.calculate(post, this.lightSize, edgeNormal);
    const rotationCorrection = THREE.Math.degToRad(180);

    lightModel.position.copy(position);
    lightModel.rotation.y =
      -Math.atan2(edgeEnd.z - edgeStart.z, edgeEnd.x - edgeStart.x) + rotationCorrection;
    post.add(lightModel);
  }

  addForTerm(post, location) {
    if (!this.hasAccentLights()) {
      return;
    }
    const light = this.lightModel.clone();
    const edgeNormal = location.direction
      .clone()
      .applyAxisAngle(this.up, THREE.Math.degToRad(-90))
      .normalize();
    const position = this.lightPositionCalculator.calculate(post, this.lightSize, edgeNormal);
    light.position.copy(position);
    light.rotation.y =
      -Math.atan2(location.direction.z, location.direction.x) + THREE.Math.degToRad(180);
    post.add(light);
  }

  addForStairs(post, location) {
    if (location.isCorner || !this.hasAccentLights()) {
      return;
    }
    const light = this.lightModel.clone();
    let directionRotationAngle, rotationCorrection;
    if (location.isBottom) {
      directionRotationAngle = 360;
      rotationCorrection = -90;
    } else if (location.isLeft) {
      directionRotationAngle = 90;
      rotationCorrection = 0;
    } else {
      directionRotationAngle = -90;
      rotationCorrection = 180;
    }
    const edgeNormal = location.direction
      .clone()
      .applyAxisAngle(this.up, THREE.Math.degToRad(directionRotationAngle))
      .normalize();
    const position = this.lightPositionCalculator.calculate(post, this.lightSize, edgeNormal);
    light.position.copy(position);
    light.rotation.y =
      -Math.atan2(location.direction.z, location.direction.x) +
      THREE.Math.degToRad(rotationCorrection);
    post.add(light);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/light/post-accent-lights-arrange.service.ts